// extracted by mini-css-extract-plugin
export default {"header":"App_header__A56gc","main":"App_main__5fNCA","footer":"App_footer__yhy8u"};